<template>
  <div class="block-howto basic-block">
    <h1>友だち追加の手順</h1>
    <ol>
      <!-- <li class="step">
        <h2>友だちになる</h2>
        <p>画面右下の「友だち追加」からLINEの画面へ移動して、「追加」ボタンをタップする。</p>
        <img class="img1" src="/static/img/lp/campaign/lineCampaign202110/image01.png">
      </li>
      <li class="step">
        <h2>無料会員になる</h2>
        <p>トーク画面からメニューの「友だち追加キャンペーン」ボタンをタップして「占いTV」に無料会員登録する。</p>
        <img class="img2" src="/static/img/lp/campaign/lineCampaign202110/image02_b.png">
      </li>
      <li class="comp">
        <h2>申し込み完了</h2>
        <p>LINEで無料占いのリンクが贈られてきます。</p>
        <img class="img3" src="/static/img/lp/campaign/lineCampaign202110/image03.png">
      </li> -->
      <li>
        <p>画面右下の「友だち追加」からLINEの『占いTV』公式アカウントの画面へ移動して、「追加」ボタンをタップします。</p>
        <img class="img4" src="/static/img/lp/campaign/lineCampaign202110/image01.png">
      </li>
      <li>
        <p>友だち追加が完了すると、トーク画面に「30秒で終わる簡単なアンケート」が送られます。アンケートに回答すると、あなたにぴったりな占いが続々配信されます！</p>
        <img class="img5" src="/static/img/lp/campaign/lineCampaign202110/image04.png">
      </li>
    </ol>
  </div>
</template>

<script>

export default {
  name: 'BlockHowto',
}
</script>

<style scoped lang="scss">
.block-howto {
  padding: 40px 20px 0;
  ol {
    list-style: none;
    padding: 16px 0 0;
    margin: 0;
    counter-reset: item;
    li {
      &.step {
        &::before {
          counter-increment: item;
          content: 'STEP'counter(item);
          background: #06C755;
          border-radius: 6px;
          color: #FFF;
          font-size: 16px;
          font-weight: bold;
          line-height: 24px;
          display: block;
          width: fit-content;
          padding: 0 13px;
          margin: 0 auto;
        }
      }
      .img1 {
        width: 100%;
        margin: 8px auto 0;
      }
      .img2 {
        width: 100%;
        margin: 8px auto 0;
      }
      .img3 {
        width: 100%;
        margin: 8px auto 0;
      }
      .img4 {
        width: 100%;
        margin: 21px auto 0;
      }
      .img5 {
        width: 100%;
        margin: 16px auto 0;
      }
    }
    li + li {
      margin: 23px 0 0 0;
    }
  }
  img {
    display: block;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/blocks/BlockHowto.vue